module.exports = __webpack_public_path__ + "static/media/15.85d6d1b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/15.jpg
// module id = 190
// module chunks = 0